import React, { Component } from "react";
import Loader from "../utils/loader";
import userService from "../services/userService";
import teamService from "../services/teamService";
import Swal from "sweetalert2";
import TeamCard from "./Cards/Teamcard";
import { toast, ToastContainer } from "react-toastify";
import PaginatioN from "react-js-pagination";
import { paginate } from "../utils/paginate";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import "./teamMembers.css";
import BreadCrumb from "./Cards/BreadCrumbs";
import HeadingB from "./Cards/HeadingB";
import Avatars from "./Avatar";
import Divider from "@material-ui/core/Divider";
import team from "../static/noteams.png"
import isEmptyObject from "../utils/isEmptyObject";
import { connect } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/style.css";
import Checkbox from "@material-ui/core/Checkbox";
import _ from "lodash";
import ReactTour from "./ReactTour";
import { showToast } from "../messages";

const steps= [
  {
    selector: '.first-step',
    content: 'Create new group to add members',
    position: 'left',
  },
  {
    selector: '.second-step',
    content: 'Enter email to send invite request to member',
    position: 'bottom',
  },
];

const stepsone= [
  {
    selector: '.first-step',
    content: 'Create new group to add members',
    position: 'left',
  },
  {
    selector: '.second-step',
    content: 'Enter email to send invite request to member',
    position: 'bottom',
  },
  {
    selector: '.third-step',
    content: 'Click to view/add members to the group',
    position: 'bottom',
  },
];

export class Myteam extends Component {
  state = {
    loading: true,
    userProfile: "",
    inviteEmail: "",
    inviteEmails: [],
    teamMembers: [],
    totalMemberCount: "",
    currentPage: 1,
    pageSize: 8,
    searchQuery: "",
    groups: [],
    otherGroups: [],
    groupMembers: [],
    groupMemberIDs: [],
    groupName: "",
    groupId: "",
    colorID: 0,
    back: [],
    color: ["#bff603", "yellow", "#80d4ff", "orange"],
    filterTeam: [],
    filterGroup: [],
    filterGroupName: [],
    filterOtherGroup: [],
    selectedMembers: [],
    userFeatures: {},
    myGroupPage: 1,
    otherGroupPage: 1,
    reactTour: false,
  };
  

  searchOnChange = (e) => {
    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroup: this.state.groupMembers,
      });
    } else {
      let value = e.target.value;
      let teamMembers = this.state.teamMembers;
      let groupMembers = this.state.groupMembers;
      let result2 = [];
      let result1 = [];
      result1 = teamMembers.filter((member) => {
        console.log(member);
        if (member.name.toLowerCase().search(value.toLowerCase()) !== -1) {
          return member;
        }
      });
      result2 = groupMembers.filter((group) => {
        console.log(group);
        if (group.username.toLowerCase().search(value.toLowerCase()) !== -1) {
          return group;
        }
      });

      this.setState({ filterTeam: result1, filterGroup: result2 });
    }
  };

  handleSearch = (e) => {
    // this.setState({ searchQuery: e.target.value });

    if (e.target.value === "") {
      this.setState({
        filterTeam: this.state.teamMembers,
        filterGroupName: this.state.groups,
        filterOtherGroup: this.state.otherGroups,
      });
    } else {
      let value = e.target.value;

      let teamMembers = this.state.teamMembers;
      let groups = this.state.groups;
      let otherGroups = this.state.otherGroups;

      let result1 = [];
      let result2 = [];
      let result3 = [];

      result1 = teamMembers.filter((member) => {
        console.log(member);
        if (member.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          return member;
        }
      });

      result2 = groups.filter((groupmember) => {
        console.log(groupmember);
        if (groupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          return groupmember;
        }
      });

      result3 = otherGroups.filter((othergroupmember) => {
        console.log(othergroupmember);
        if (
          othergroupmember.name.toLowerCase().indexOf(value.toLowerCase()) > -1
        ) {
          return othergroupmember;
        }
      });

      this.setState({
        filterTeam: result1,
        filterGroupName: result2,
        filterOtherGroup: result3,
      });
    }
  };

  async componentDidMount() {
    this.getTeam();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.groupId !== this.state.groupId) {
      this.setState({ selectedMembers: [] });
    }
  }

  getProfile = async () => {
    let user;
    const { currentUser, setCurrentUser, features } = this.props;
    if (currentUser && !isEmptyObject(currentUser)) {
      // user = { ...currentUser };
      user = await userService.getProfile();
      user = user.data;
    } else {
      user = await userService.getProfile();
      console.log("currentUser", user);
      user = user.data;
      setCurrentUser(user);
    }
    this.setState({ userProfile: user, userFeatures: features }, () => {
      this.getOtherGroups();
    });
  };

  getOtherGroups = async () => {
    let other = this.state.userProfile.groups;

    if (other.length > 0) {
      const othergroups = await teamService.getGroupById(other);
      console.log(othergroups);
      this.setState({
        otherGroups: othergroups.data,
        filterOtherGroup: othergroups.data,
      });
    } else {
      this.setState({ otherGroups: [] });
    }
    this.setState({ loading: false });
  };

  //  Get All Team Members
  getTeam = async () => {
    const teamMembers = await userService.getTeam();
    if (teamMembers.status !== 200) {
      if (!this.state.teamMembers.length > 0) {
        // toast.error(teamMembers.message);
        this.setState({ teamMembers: [], filterTeam: [] }, () => {
          this.getGroup();
        });
      } else {
        this.setState({ teamMembers: [], filterTeam: [] }, () => {
          this.getGroup();
        });
      }
    } else {
      this.setState(
        {
          filterTeam: teamMembers.data.user,
          teamMembers: teamMembers.data.user,
          totalMemberCount: teamMembers.data.user.length,
        },
        () => {
          this.getGroup();
        }
      );
    }
  };

  // Get All Groups
  getGroup = async () => {
    const group = await teamService.getAllGroups();
    if (group.status === 200) {
      this.setState({ groups: group.data, filterGroupName: group.data }, () => {
        this.getProfile();
      });
    } else {
      console.log(group.message);
      this.getProfile();
    }
  };

  // Delete Member
  handleDelete = async (user) => {
    Swal.fire({
      title: "Are you sure?",
      text: `"Do you want to remove this team member"`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = {
          id: user.id,
        };
        const team = await userService.deleteTeam(data);
    
        if (team.status === 200) {
          this.getTeam();
          Swal.fire("Deleted!", `${team.message}`, "success");
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${team.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your team member is safe :)", "error");
      }
    });


   

    // if (team.status !== 200) {
    //   this.setState({ loading: false });
    //   toast.error(team.message);
    // } else {
    //   toast.success(team.message);
    //   this.getTeam();
    // }
  };

  // Pagination Page
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  // Handle Email Invite
  handleSendInvite = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Handle Group Name
  handleGroupName = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Send Invite
  sendInvite = async (e) => {
    if (this.state.userFeatures.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }
    this.setState({ loading: true });
    e.preventDefault();
    let email = this.state.inviteEmails;
    if (email.length < 1) {
      this.setState({ loading: false });
      showToast('signup.email')
    } else {
      const team = await teamService.inviteMember(email);
      if (team.status !== 200) {
        this.setState({ loading: false });
        toast.error(team.message);
      } else {
        this.setState({ loading: false });
        toast.success(team.message, {});
        // this.getTeam();
      }
    }
    this.setState({ inviteEmails: [] });
  };

  // Set Group
  setGroup = async (groupid, groupmembers) => {
    let team = this.state.filterTeam;
    this.setState(
      {
        filterTeam: [],
        groupMembers: [],
        filterGroup: [],
        groupId: groupid,
        loading: true,
      },
      () => this.setState({ filterTeam: team })
    );

    if (groupmembers.length > 0) {
      const groupdata = await teamService.getGroupMembers(groupmembers);
      if (groupdata.status === 200) {
        this.setState({
          groupMembers: groupdata.data,
          filterGroup: groupdata.data,
        });
      }
    }
    this.setState({ loading: false, groupMemberIDs: groupmembers });
  };

  // Create Group
  createGroup = async (e) => {
    e.preventDefault();
    if (this.state.userFeatures.TeamManagement === false) {
      toast("Please upgrade your plan to enable team member features");
      return;
    }

    this.setState({ loading: true });
    let currentGroup = this.state.groups;
    let groupName = this.state.groupName;

    let userProfile = this.state.userProfile;
    let match = 0;

    if (groupName === "") {
      this.setState({ loading: false });
      showToast('Organization.invalidGroup')
      return;
    }

    if (currentGroup.length > 0) {
      for (let i = 0; i < currentGroup.length; i++) {
        if (groupName === currentGroup[i].name) {
          this.setState({ loading: false, groupName: "" });
          toast(`${groupName} Already exists!`);
          match = 1;
          return;
        }
      }
    }

    if (match === 0) {
      let data = {
        groupname: groupName,
        ownerName: userProfile.username,
      };
      const team = await teamService.createGroup(data);
      if (team.status === 200) {
        this.getGroup();
        toast.success(team.message);
      } else {
        this.setState({ loading: false });
        toast.error(team.message);
      }
    }

    this.setState({ groupName: "" });
  };

  onChangeSelectionBox = (team) => (e) => {
    let selected = this.state.selectedMembers;
    if (e.target.checked === true) {
      selected.push(team.id);
    } else {
      selected.splice(selected.indexOf(team.id), 1);
    }
    this.setState({ selectedMembers: selected });
  };

  // Add Members To Group
  addMembersToGroup = async () => {
    let groupMembers = this.state.groupMemberIDs;
    let selectedMembers = this.state.selectedMembers;

    if (selectedMembers.length < 1) {
      toast("No Member selected");
      return;
    } else {
      let presents = _.intersectionWith(
        groupMembers,
        selectedMembers,
        _.isEqual
      );
      if (presents.length > 0) {
        for (let i = 0; i < presents.length; i++) {
          selectedMembers.splice(selectedMembers.indexOf(presents[i]), 1);
        }
      }
    }

    if (selectedMembers.length > 0) {
      let data = {
        memberArray: selectedMembers,
        groupID: this.state.groupId,
      };

      const res = await teamService.addMemberToGroup(data);
      if (res.status === 200) {
        this.getGroup();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
      this.setState({ selectedMembers: [] });
      return;
    } else {
      toast("Member already exists");
      return;
    }
  };

  // Add Members To Group
  // addMemberToGroup = async team => {
  //   let groupMembers = this.state.groupMembers;

  //   for (let i = 0; i < groupMembers.length; i++) {
  //     if (team.id === groupMembers[i]._id) {
  //       toast("Member Already Exist in Group !");
  //       return;
  //     }
  //   }

  //   let data = {
  //     memberID: team.id,
  //     groupID: this.state.groupId
  //   };

  //   const res = await teamService.addMemberToGroup(data);
  //   if (res.status === 200) {
  //     this.getGroup();
  //     toast.success(res.message);
  //   } else {
  //     toast.error(res.message);
  //   }
  // };

  // Remove Member from Group
  removeMemberFromGroup = async (id) => {
    let data = {
      memberID: id,
      groupID: this.state.groupId,
    };

    const res = await teamService.removeMemberFromGroup(data);
    if (res.status === 200) {
      this.getGroup();
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
  };

  // Leave Group
  leaveGroup = async () => {
    this.setState({ loading: true });
    let data = {
      _id: this.state.groupId,
    };
    const response = await teamService.leaveGroup(data);
    if (response.status === 200) {
      this.getProfile();
      toast.success(response.message);
    } else {
      toast.error(response.message);
      this.setState({ loading: false });
    }
  };

  // Delete Group
  deleteGroup = async (group) => {
    Swal.fire({
      title: "Are you sure?",
      text: `"Do you want to delete ${group.name}"`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value === true) {
        this.setState({ loading: true });
        let data = {
          _id: group._id,
          members: group.members,
        };

        const response = await teamService.deleteGroup(data);
        if (response.status === 200) {
          this.getGroup();
          Swal.fire("Deleted!", `${response.message}`, "success");
        } else {
          this.setState({ loading: false });
          Swal.fire("Cancelled", `${response.message}`, "error");
        }
      } else {
        Swal.fire("Cancelled", "Your Group is safe :)", "error");
      }
    });
  };

  getPagedData = () => {
    let {
      teamMembers,
      currentPage,
      pageSize,
      searchQuery,
      filterGroupName,
      filterOtherGroup,
    } = this.state;

    let filteredMembers = teamMembers;

    if (searchQuery) {
      filteredMembers = teamMembers.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterGroupName = filterGroupName.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
      filterOtherGroup = filterOtherGroup.filter((team) =>
        team.name.toLowerCase().startsWith(searchQuery.toLowerCase())
      );
    }

    const team = paginate(filteredMembers, currentPage, pageSize);
    const myGroups = paginate(filterGroupName, this.state.myGroupPage, 9);
    const otherGroups = paginate(
      filterOtherGroup,
      this.state.otherGroupPage,
      9
    );

    return {
      totalMemberCount: filteredMembers.length,
      teamMembers: team,
      myGroups: myGroups,
      paginateOtherGroups: otherGroups,
      myGroupsCount: filterGroupName.length,
      otherGroupsCount: filterOtherGroup.length,
    };
  };

  render() {
    let {
      currentPage,
      groups,
      otherGroups,
      filterTeam,
      filterGroup,
      filterGroupName,
      filterOtherGroup,
    } = this.state;

    let {
      teamMembers,
      totalMemberCount,
      myGroups,
      paginateOtherGroups,
      myGroupsCount,
      otherGroupsCount,
    } = this.getPagedData();

    const popover = (
      <Popover id="popover-basic" style={{ zIndex: "9999", padding: "2px" }}>
        <Popover.Content>
          <p>*NOTE - Multiple invites can be sent</p>

          <ReactMultiEmail
            placeholder="Invite Members"
            emails={this.state.inviteEmails}
            onChange={(_emails) => {
              this.setState({ inviteEmails: _emails });
            }}
            validateEmail={(email) => {
              return isEmail(email); // return boolean
            }}
            getLabel={(email, index, removeEmail) => {
              return (
                <div data-tag key={index}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>
              );
            }}
          />

          <Button
            className="btn btn-outline w-100 mt-2"
            onClick={this.sendInvite}
          >
            Invite
          </Button>

          {/* <form onSubmit={this.sendInvite}>
            <InputGroup className="mb-3">
              <FormControl
                type="email"
                name="inviteEmail"
                value={this.state.inviteEmail}
                onChange={this.handleSendInvite}
                placeholder="Member Email"
                aria-label="Member Email"
                aria-describedby="basic-addon2"
              />

              <InputGroup.Append>
                <Button variant="outline-primary" type="submit">
                  Invite
                </Button>
              </InputGroup.Append>
            </InputGroup>
          </form> */}
        </Popover.Content>
      </Popover>
    );

    const pop = (
      <Popover id="popover-basic" style={{ zIndex: "1010", padding: "5px" }}>
        <Popover.Content>
          <h6 style={{ fontFamily: "Roboto" }}>Create a new group</h6>
          {/* <button className="btn btn-outline-danger" onClick={this.ok}>Create Group</button> */}
          <form onSubmit={this.createGroup}>
            <InputGroup className="mb-3">
              <FormControl
                type="text"
                name="groupName"
                value={this.state.groupName}
                onChange={this.handleGroupName}
                placeholder="Group Title"
                aria-label="Group Title"
                aria-describedby="basic-addon2"
              />
              <InputGroup.Append>
                <Button variant="primary" type="submit">
                  Create
                </Button>
              </InputGroup.Append>
            </InputGroup>
          </form>
        </Popover.Content>
      </Popover>
    );

    return (
      <div>
        <Loader loading={this.state.loading} />
        <ToastContainer />

        <div className="" style={{ background: "#f0f0f7" }}>
          <BreadCrumb l1="Home" l2="My Team" dashboardlink="/dashboard" />

          <div className="row ">
            {/* Title */}
            <div className="col-md-1">
              <HeadingB text="Teams" />

              {/* <p className="ft_lg text-e">Teams</p> */}
            </div>

            {/* Search Bar */}
            <div className="col-md-6">
              <input
                className="form-control searchBar"
                name="searchQuery"
                onChange={this.handleSearch}
                type="text"
                placeholder="&#xF002; Search group or Team Member"
                aria-label="Search"
                style={{
                  fontFamily: "FontAwesome",
                  border: "none",
                  width: "60%",
                  float: "left",
                }}
              />
            </div>

            {/* Create Group Button */}
            <div className="first-step col-sm-2 text-right">
              <OverlayTrigger
                trigger="click"
                placement="bottom"
                overlay={pop}
                rootClose={true}
              >
                <button
                  className="btn btn-primary createGroup"
                  style={{ width: "90%" }}
                >
                  Create group
                </button>
              </OverlayTrigger>
            </div>

            {/* Send Invite Button */}
            <div className="second-step col-sm-2">
              <OverlayTrigger
                trigger="click"
                placement="bottom"
                overlay={popover}
                rootClose={true}
              >
                <button
                  className="btn btn-primary inviteMember"
                  style={{ width: "90%" }}
                >
                  Invite
                  {/* <i className="fa fa-plus-circle" aria-hidden="true">
                    &nbsp; 
                  </i> */}
                </button>
              </OverlayTrigger>
            </div>
              
            <div className="col-md-1"> 
              <i 
                className="fa fa-question-circle mt-2" 
                aria-hidden="true"
                data-toggle="tooltip"
                title="Need Help ?"
                style={{
                  cursor: "pointer",
                  color: "dodgerblue",
                  fontSize: "15px"
                }}
                onClick={()=>this.setState({ reactTour: true })}
              ></i>
            </div>

          </div>
          <br />
          <Divider light />

          {teamMembers.length === 0 && groups.length === 0 && otherGroups.length === 0 ? (
            <div className="text-center">
              <h1 style={{ marginTop: "15%" }}>
               <img src={team} style={{marginTop:"-65px"}}/>
              </h1>
            </div>
          ) : (
            <>
              {teamMembers.length > 0 && (
                <p className="mt-4 mb-2 ft_md ft-wt-500" style={{color:"#3e80f1"}}>Team Members</p>
              )}
              {/* User Cards */}
              {/* <TeamCard teamdata={teamMembers} grpData={groups} /> */}
              <div className="row pl-2">
                {filterTeam.map((team) => (
                  <TeamCard
                    teamdata={team}
                    grpData={groups}
                    deleteMember={() => this.handleDelete(team)}
                  />
                ))}
              </div>

              <div className="row">
                {/* Pagination */}
                {totalMemberCount > 8 ? (
                  <div
                    className="row ml-auto"
                    style={{ margin: "2% 1% 0% 0%" }}
                  >
                    <PaginatioN
                      activePage={currentPage}
                      itemsCountPerPage={this.state.pageSize}
                      totalItemsCount={totalMemberCount}
                      pageRangeDisplayed={3}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>

              {groups.length > 0 && (
                <p className="mt-4 mb-2 ft_md ft-wt-500" style={{color:"#3e80f1"}}>My Groups</p>
              )}

              {/* Group Cards */}
              <div className="row">
                {filterGroupName.length > 0 &&
                  myGroups.map((group) => (
                    <div
                      className="col-md-4 res-Group-card DocumentCardHover third-step"
                      key={group._id}
                      style={{ marginTop: "1%" }}
                    >
                      <div className="card setShadow">
                        <div className="card-body">
                          <div className="row">
                            <div className="ml-2">
                              <Avatars
                                onClick={() =>
                                  this.setGroup(group._id, group.members)
                                }
                                name={group.name.charAt(0).toUpperCase()}
                                colorIndex={groups.indexOf(group) % 4}
                              />
                            </div>
                            {/* Group Detail */}
                            <div
                              onClick={() =>
                                this.setGroup(group._id, group.members)
                              }
                              className="col-6"
                              data-toggle="modal"
                              data-target="#myModal"
                              style={{
                                cursor: "pointer",
                                paddingRight: "3%",
                                //marginTop: "4%"
                              }}
                            >
                              <p className="ft_lg m-0">
                                <small>
                                  <strong>{group.name}</strong>
                                </small>
                              </p>
                              <p className="ft_sm text-a m-0">
                                <small>{group.members.length} Members</small>{" "}
                              </p>
                              <p className="ft_sm text-a m-0">
                                <small>
                                  <strong>Admin : </strong>
                                </small>
                                <small>{this.state.userProfile.username}</small>
                              </p>
                            </div>

                            {/* Delete Button */}
                            <div className="col-2 ml-auto hvr-grow">
                              <i
                                className="fa fa-trash text-primary p-1 "
                                style={{
                                  cursor: "pointer",
                                }}
                                data-placement="right"
                                title="Delete Group"
                                aria-hidden="true"
                                onClick={() => this.deleteGroup(group)}
                              ></i>
                              {/* <IconButton aria-label="settings">
                            <i
                              className="fa fa-trash"
                              style={{ fontSize: "14px", color: "#007bff" }}
                              aria-hidden="true"
                              data-toggle="tooltip"
                              data-placement="right"
                              title="Delete Group"
                              onClick={() => this.deleteGroup(group)}
                              data-dismiss="modal"
                            ></i>
                          </IconButton> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              {/* My Groups Pagination */}
              <div className="row">
                {myGroupsCount > 9 ? (
                  <div
                    className="row ml-auto"
                    style={{ margin: "2% 1% 0% 0%" }}
                  >
                    <PaginatioN
                      activePage={this.state.myGroupPage}
                      itemsCountPerPage={9}
                      totalItemsCount={myGroupsCount}
                      pageRangeDisplayed={3}
                      onChange={(page) => this.setState({ myGroupPage: page })}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>

              {otherGroups.length > 0 && (
                <p className="mt-4 mb-2 ft_md ft-wt-500" style={{color:"#3e80f1"}}>Other Groups</p>
              )}

              {/* Other Group Cards otherGroups */}
              <div className="row">
                {filterOtherGroup.length > 0 &&
                  paginateOtherGroups.map((group) => (
                    <div
                      className="col-md-4 res-Group-card DocumentCardHover"
                      key={group._id}
                      style={{ marginTop: "1%" }}
                    >
                      <div className="card setShadow">
                        <div className="card-body">
                          <div className="row">
                            <div className="ml-2">
                              <Avatars
                                name={group.name.charAt(0).toUpperCase()}
                                colorIndex={otherGroups.indexOf(group) % 4}
                              />
                            </div>

                            {/* Group Detail */}
                            <div
                              onClick={() =>
                                this.setGroup(group._id, group.members)
                              }
                              className="col-8"
                              data-toggle="modal"
                              data-target="#SharedGroupModal"
                              style={{ cursor: "pointer" }}
                            >
                              <p className="m-0">
                                <small>
                                  <strong>{group.name}</strong>
                                </small>
                              </p>
                              <p className="text-a m-0">
                                <small>{group.members.length} Members</small>
                              </p>
                              <p className="text-a m-0">
                                <small>
                                  <strong>Admin : </strong>
                                </small>
                                <small>{group.owner ?group.owner.username : 'PET User'}</small>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>

              {/* Other Groups Pagination */}
              <div className="row">
                {otherGroupsCount > 9 ? (
                  <div
                    className="row ml-auto"
                    style={{ margin: "2% 1% 0% 0%" }}
                  >
                    <PaginatioN
                      activePage={this.state.otherGroupPage}
                      itemsCountPerPage={9}
                      totalItemsCount={otherGroupsCount}
                      pageRangeDisplayed={3}
                      onChange={(page) =>
                        this.setState({ otherGroupPage: page })
                      }
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}
        </div>

        {/* <!-- Admin Group Modal --> */}
        <div class="modal fade" id="myModal">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              {/* <!-- Modal Header --> */}
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div class="modal-body">
                <div className="row">
                  <input
                    className="form-control search"
                    type="text"
                    onChange={this.searchOnChange}
                    placeholder="&#xF002; Search Username / Group"
                    aria-label="Search"
                    style={{
                      backgroundColor: "#f2f2f2",
                      fontFamily: "FontAwesome",
                      height: "50px",
                      marginTop: "-16px",
                      border: " 0px solid",
                      paddingLeft: "25px",
                      marginLeft: "1px",
                      width: "498px",
                    }}
                  />
                </div>
                <div className="row pt-2">
                  <div className="col">
                    <h6 className="teamHead">Group Members</h6>
                  </div>
                </div>

                <div
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "20vh",
                  }}
                >
                  {filterGroup.length > 0 &&
                    filterGroup.map((group) => (
                      <div
                        className="row"
                        key={group._id}
                        style={{ marginTop: "5%" }}
                      >
                        <div className="col-3">
                          {/* User Display Picture */}
                          <img
                            className=""
                            src={group.display_picture}
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          ></img>
                        </div>
                        <div className="col-7">
                          {/* <p className="ft_lg m-0"> */}
                          <small>
                            <strong className="adminGrpUserName">
                              {group.username}
                            </strong>
                          </small>
                          {/* </p> */}
                        </div>

                        {/* Delete Button */}
                        <div className="col-2">
                          <i
                            className="fa fa-trash adminGrpDeleteBtn"
                            style={{ color: "red" }}
                            aria-hidden="true"
                            onClick={() =>
                              this.removeMemberFromGroup(group._id)
                            }
                            data-dismiss="modal"
                          ></i>
                        </div>
                      </div>
                    ))}
                </div>

                <hr />

                <div className="row">
                  <div className="col-md-4">
                    <h6 className="teamHead">Friend List</h6>
                  </div>
                  <div className="col-md-4"></div>
                  <div className="col-md-4" style={{ paddingLeft: "100px" }}>
                    <button
                      className="btn btn-primary"
                      onClick={this.addMembersToGroup}
                      data-dismiss="modal"
                    >
                      ADD
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "20vh",
                  }}
                >
                  {filterTeam.length > 0 &&
                    filterTeam.map((team) => (
                      <div
                        className="row"
                        key={team._id}
                        style={{ marginTop: "5%" }}
                      >
                        <div className="col-3">
                          {/* User Display Picture */}
                          <img
                            className=""
                            src={team.picture}
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          ></img>
                        </div>
                        <div className="col-7">
                          <p className="">
                            <small>
                              <strong className="adminGrpUserName">
                                {team.name || "-"}
                              </strong>
                            </small>
                          </p>
                        </div>

                        {/* ADD Button */}
                        <div className="col-2">
                          <Checkbox
                            color="primary"
                            onChange={this.onChangeSelectionBox(team)}
                          />
                          {/* <i
                            className="fa fa-plus adminGrpDeleteBtn"
                            style={{ color: "#007bff" }}
                            aria-hidden="true"
                            onClick={() => this.addMemberToGroup(team)}
                            data-dismiss="modal"
                          ></i> */}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Admin Group Modal */}

        {/* Shared Group Modal */}
        <div class="modal fade" id="SharedGroupModal">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              {/* <!-- Modal Header --> */}
              <div class="modal-header">
                <h4 class="modal-title">Group Members</h4>
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              {/* <!-- Modal body --> */}
              <div class="modal-body">
                {/* Search Bar */}
                <div className="row">
                  <input
                    className="form-control grp_mem_searchBar "
                    type="text"
                    onChange={this.searchOnChange}
                    placeholder="&#xF002; Search Username / Group"
                    aria-label="Search"
                    style={{
                      backgroundColor: "#f2f2f2",
                      fontFamily: "FontAwesome",
                      height: "50px",
                      marginTop: "-16px",
                      border: " 0px solid",
                      paddingLeft: "50px",
                      marginLeft: "1px",
                      width: "498px",
                    }}
                  />
                </div>

                {/* Members */}
                <div
                  style={{
                    overflowY: "auto",
                    overflowX: "hidden",
                    height: "20vh",
                  }}
                >
                  {filterGroup.length > 0 &&
                    filterGroup.map((group) => (
                      <div
                        className="row"
                        key={group._id}
                        style={{ marginTop: "5%" }}
                      >
                        <div className="col-3">
                          {/* User Display Picture */}
                          <img
                            className=""
                            src={group.display_picture}
                            alt=""
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                            }}
                          ></img>
                        </div>
                        <div className="col-9  m-0 grp_mem_modal_text">
                          <small>
                            <strong className="adminGrpUserName">
                              {group.username}
                            </strong>
                          </small>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-danger mr-auto"
                  onClick={() => this.leaveGroup()}
                  data-dismiss="modal"
                >
                  <i class="fa fa-sign-out" aria-hidden="true"></i> Leave Group
                </button>
                <button className="btn btn-secondary" data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Shared Group Modal */}
        <ReactTour 
          steps={groups.length > 0 ? stepsone : steps} 
          isOpen={this.state.reactTour} 
          closeTour={()=>this.setState({ reactTour: false })}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});
const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Myteam);
